export function getFullUrlPath(path) {
    var _a;
    if (!path)
        return path;
    const origin = typeof window !== "undefined"
        ? (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.origin
        : "https://www.haven.com";
    try {
        const url = new URL(path, origin);
        return url.href.toLowerCase();
    }
    catch (e) {
        return `${origin}${path}`.toLowerCase();
    }
}
